<template>
  <v-menu offset-y>
    <template v-slot:activator="{ props }">
      <v-btn variant="text" v-bind="props" size="small" class="lang-btn">
        <span class="flag">{{ localeStore.flag }}</span>
        <span class="lang-name ml-1">{{ localeStore.langName }}</span>
        <v-icon size="16" class="ml-1">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <v-list density="compact" bg-color="#1E1E1E">
      <v-list-item
        v-for="lang in supported"
        :key="lang"
        :class="{ 'active-lang': lang === localeStore.locale }"
        @click="localeStore.setLocale(lang)"
      >
        <template v-slot:prepend>
          <span class="flag mr-2">{{ flags[lang] }}</span>
        </template>
        <v-list-item-title>{{ names[lang] }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { useLocaleStore, localeNames, localeFlags, SUPPORTED_LOCALES } from '@/stores/locale'

export default {
  name: 'LanguageSelector',
  computed: {
    localeStore() { return useLocaleStore() },
    supported() { return SUPPORTED_LOCALES },
    names() { return localeNames },
    flags() { return localeFlags },
  }
}
</script>

<style scoped>
.lang-btn { text-transform: none; letter-spacing: 0; }
.flag { font-size: 18px; }
.lang-name { font-size: 13px; color: #94a3b8; }
.active-lang { background: rgba(126, 87, 194, 0.15); }
</style>
